import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslate } from '../contexts/I18nContext';

const STORAGE_KEY = 'plancity_cookie_consent';

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { translateText } = useTranslate();

  useEffect(() => {
    const t = setTimeout(() => {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    setVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, dismissed: true, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-[9999] animate-slideUp"
      data-testid="cookie-banner"
    >
      <div className="bg-neutral-900/95 backdrop-blur ring-1 ring-white/10 rounded-2xl shadow-2xl p-4 md:p-5">
        <div className="flex items-start justify-between gap-3 mb-2">
          <h3 className="text-sm font-bold text-white">{translateText('Usamos cookies')} 🍪</h3>
          <button
            onClick={handleDismiss}
            className="text-neutral-400 hover:text-white transition-colors -mr-1"
            aria-label={translateText('Cerrar')}
            data-testid="cookie-banner-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <p className="text-xs text-neutral-300 leading-relaxed mb-4">
          {translateText('Usamos cookies estrictamente necesarias para que el sitio funcione (sesión, idioma) y detectamos tu región desde tu conexión para mostrarte panoramas cercanos. Siempre puedes cambiarla desde el selector. Al continuar aceptas nuestra')}{' '}
          <Link to="/cookies" className="text-[#00CC66] hover:underline">{translateText('Política de Cookies')}</Link>{' '}
          {translateText('y')}{' '}
          <Link to="/privacidad" className="text-[#00CC66] hover:underline">{translateText('Política de Privacidad')}</Link>.
        </p>
        <div className="flex items-center gap-2">
          <Button
            onClick={handleAccept}
            className="bg-[#00CC66] hover:bg-[#00b85b] text-neutral-900 font-semibold rounded-full text-xs px-4 py-2 flex-1"
            data-testid="cookie-banner-accept"
          >
            {translateText('Aceptar')}
          </Button>
          <Link to="/cookies" className="flex-1">
            <Button
              variant="outline"
              className="w-full rounded-full text-xs px-4 py-2 bg-transparent border-white/20 text-white hover:bg-white/10"
              data-testid="cookie-banner-more"
            >
              {translateText('Más info')}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
